import truncate from 'lodash/truncate'

/**
 * @example getTruncatedString('Some very long string here again') // 'Some very long...'
 */
export const getTruncatedString = (str: string | undefined): string => {
  return truncate(str ?? '', { length: 30, omission: '...' })
}
